import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { BankItem, } from '../shared/interfaces/bank-response.interface';
import { API_URL } from '../app.module';
import { DistinctValuesResponse } from '../shared/interfaces/distinct-values-response.interface';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(
    @Inject(API_URL) public baseUrl: string,
    public http: HttpClient,
  ) {}

  getCurrencyWithBank() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', // Set the appropriate content type
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
    });
    const baseUrl = this.baseUrl + 'banks/currencies-banks-accounts';
    return this.http.get(baseUrl, { headers });
  }

  getBankFilterDistinctValues(): Observable<DistinctValuesResponse> {
    return this.http.get<DistinctValuesResponse>(`${this.baseUrl}banks/filter-distinct-values`);
  }

  updateBankData(data: BankItem): Observable<BankItem> {
    const baseUrl = this.baseUrl + 'banks/insert-with-check-for-duplicates';
    return this.http.post<BankItem>(baseUrl, data);
  }


  validateFile(file: any): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    const baseUrl = this.baseUrl + 'banks/validate-import';
    return this.http.post(baseUrl,formData);
  }

  uploadFile(file: any): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    const baseUrl = this.baseUrl + 'banks/import-with-check-duplicates';
    return this.http.post(baseUrl,formData);
  }

  uploadMT103File(file: any): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    const baseUrl = this.baseUrl + 'spool/import-spool-file';
    return this.http.post(baseUrl,formData);
  }

  getFilterDistinctValues(): Observable<DistinctValuesResponse> {
    return this.http.get<DistinctValuesResponse>(`${this.baseUrl}entity/filter-distinct-values`);
  }

  queryCleaner<T>(params: Partial<T>): { [key: string]: any } {
    for (const paramsKey in params) {
      if (!params[paramsKey as keyof T] && params[paramsKey as keyof T] !== 0) {
        delete (params as any)[paramsKey];
      }
    }
    return params;
  }

  queryCleanerBulk<T>(params: Partial<T>): { [key: string]: any } {
    for (const paramsKey in params) {
      if (!params[paramsKey as keyof T] || params[paramsKey as keyof T] === '~') {
        (params as any)[paramsKey] = null;
      }
    }
    return params;
  }
}
